import React, {Component} from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  componentDidCatch(error, info) {
    this.setState({hasError: true});
  }

  render() {
    const {errorMessage = 'Something went wrong.'} = this.props;
    if (this.state.hasError) {
      return (
        <div className="app-wrapper page-error-container animated slideInUpTiny animation-duration-3">
          <div className="page-error-contect">
            <div className="error-code mb-4 animated zoomInDown">500</div>
            <h2 className="text-center fw-regular title bounceIn animated-delay-10 animated">
              {errorMessage}
            </h2>
            <p
              className="text-center zoomIn animation-delay-20 animated"
              onClick={() => this.handleClick()}
            >
              Sign In Again
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
